import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd';


const StyledWrapper = styled.a`
	display: inline-block;
	padding: .75rem 1.25rem;
    text-align: center;
	color: #fff;
	text-transform: uppercase;
	font-size: 1rem;
	letter-spacing: .15rem;
	transition: all .3s;
	position: relative;
	overflow: hidden;
    text-decoration: none;
	z-index: 1;
    width: 100%;
	&:after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #0e3351;
		z-index: -2;
	}
	&:before {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 0%;
		height: 100%;
		background-color: #4db2bc;
		transition: all .3s;
		z-index: -1;
	}
	&:hover {
		color: white;
        text-decoration: none;
		&:before {
			width: 100%;
		}
	}
`
const AnimatedBtnWrapper = (props) => {
    return(
         <StyledWrapper {...props} >
             {props.text}
        </StyledWrapper>
    )
}

export default AnimatedBtnWrapper